// Version FRANÇAISE — c'est la version de référence. Les cinq autres fichiers
// de ce dossier en sont des traductions de confort : si l'une d'elles diverge,
// c'est celle-ci qui fait foi (voir la ligne `mentionTraduction` des autres).
//
// Toute modification de fond faite ici doit être reportée dans les cinq autres
// fichiers, sans quoi un acheteur néerlandophone lira une version périmée.

import { COURRIEL, TELEPHONE, adresseVendeur, encadreIdentite } from './identite';

const ADRESSE = adresseVendeur('Belgique');

export default {
  cgv: {
    seoTitre: 'Conditions Générales de Vente',
    seoDescription:
      "Conditions générales de vente de MirumGames : commande, prix, paiement, droit de rétractation de 14 jours, livraison et garanties.",
    titre: 'Conditions Générales de Vente',
    maj: 'Dernière mise à jour : 23/09/2026',
    sections: [
      {
        titre: 'Article 1 : Généralités',
        blocs: [
          { p: "Toute commande passée sur le site MIRUMGAMES.COM implique l'acceptation préalable de ces conditions générales. Le client reconnaît être conscient de l'accord concernant le contenu de ces conditions générales sans réserve." },
        ],
      },
      {
        titre: 'Article 2 : Objet',
        blocs: [
          { p: "Ces conditions générales définissent les droits et obligations des parties impliquées dans les transactions en ligne de produits et services offerts par MirumGames.com au consommateur." },
        ],
      },
      {
        titre: 'Article 3 : Prix et Paiement',
        blocs: [
          { p: "Les prix sont donnés en euros et incluent la TVA applicable. Ils n'incluent pas les frais de livraison qui sont facturés séparément. Le paiement complet doit être effectué au moment de la validation de la commande." },
          { p: 'MirumGames.com accepte les paiements par carte bancaire via STRIPE, un prestataire de paiement sécurisé certifié.' },
          { p: "Chaque commande payée donne lieu à une facture au nom de l'acheteur, disponible sur la page de confirmation de la commande, par le lien de l'e-mail de confirmation et, pour les clients disposant d'un compte, dans « Mes Commandes ». Stripe envoie en outre un reçu de paiement par e-mail." },
        ],
      },
      {
        titre: 'Article 4 : Droit de Rétractation',
        blocs: [
          { p: "Tout consommateur privé dispose d'un délai de 14 jours pour retourner les produits ne lui convenant pas. Ce délai court à partir du jour de la livraison." },
          { p: 'Conditions de retour :' },
          {
            liste: [
              "Les produits doivent être retournés dans leur emballage d'origine, en parfait état de revente",
              "Les produits ayant montré des signes d'usure ne seront pas acceptés",
              'Les frais de retour sont à la charge du consommateur',
              'Le remboursement sera effectué par virement bancaire dans les 15 jours',
            ],
          },
        ],
      },
      {
        titre: 'Article 5 : Garantie Commerciale',
        blocs: [
          { p: "MirumGames.com garantit les produits contre les défauts cachés conformément à la législation belge. MirumGames.com n'est pas le producteur des articles proposés et décline toute responsabilité pour les dommages causés par un défaut de produit." },
          { p: "La responsabilité du vendeur se limite à l'échange ou au remboursement du produit défectueux." },
        ],
      },
      {
        titre: 'Article 6 : Disponibilité des Produits',
        blocs: [
          { p: "Les offres sont soumises à la disponibilité des stocks. Les images, couleurs, dimensions et poids sont fournis à titre informatif et ne sont pas contractuels. MirumGames.com décline toute responsabilité pour les variations des caractéristiques du produit." },
        ],
      },
      {
        titre: 'Article 7 : Livraison',
        blocs: [
          { p: "Les produits seront livrés à l'adresse indiquée par le consommateur sur le formulaire de commande. L'adresse doit être une adresse physique (pas de boîte postale)." },
          { p: "Nous expédions vers la Belgique, la France, le Luxembourg, les Pays-Bas, l'Allemagne et l'Espagne. Délais de livraison moyens :" },
          {
            liste: [
              'Luxembourg, Belgique, Pays-Bas : 1 à 2 jours ouvrables',
              'France, Allemagne : 2 à 4 jours ouvrables',
              'Espagne : 4 à 5 jours ouvrables',
            ],
          },
          { p: 'Note : le délai de préparation (1 jour ouvrable en moyenne) doit être pris en compte.' },
        ],
      },
      {
        titre: 'Article 8 : Conformité de la Livraison',
        blocs: [
          { p: "À la réception, le consommateur doit vérifier la conformité des produits avec le bon de commande. Tout défaut doit être signalé sur le bon de livraison avec des réserves manuscrites." },
          { p: "Toute anomalie (produit manquant, endommagé, etc.) doit être communiquée à MirumGames.com dans les 96 heures suivant la notification de l'expédition." },
        ],
      },
      {
        titre: 'Article 9 : Responsabilité',
        blocs: [
          { p: 'MirumGames.com ne peut être tenue responsable pour les dommages causés par la mauvaise utilisation ou une manutention inadéquate des produits après la livraison.' },
        ],
      },
      {
        titre: 'Article 10 : Droit Applicable',
        blocs: [
          { p: "Ces conditions générales sont régies par le droit belge. En cas de litige, le consommateur est invité à contacter MirumGames.com pour trouver une solution à l'amiable." },
        ],
      },
      {
        titre: 'Mentions Légales',
        blocs: [
          { p: 'Pour consulter les informations légales complètes de l\'entreprise (coordonnées, TVA, etc.), veuillez consulter notre <a href="/legal" class="text-blue-600 hover:text-blue-800 underline">page Mentions Légales</a>.' },
          { p: "Les commandes dont le paiement a été encaissé jusqu'au 22/09/2026 inclus (heure de Belgique) ont pour vendeur Charlotte Ansiaux (BCE 1000.107.018), qui le reste ; celles dont le paiement est encaissé à partir du 23/09/2026 ont pour vendeur Sébastien Schoonjans." },
        ],
      },
    ],
  },

  confidentialite: {
    seoTitre: 'Politique de Confidentialité',
    seoDescription:
      'Politique de confidentialité de MirumGames : données collectées, usage, cookies, mesure d\'audience anonyme et droits RGPD.',
    titre: 'Politique de Confidentialité',
    maj: 'Dernière mise à jour : 23/09/2026',
    sections: [
      {
        titre: '1. Collecte des Données Personnelles',
        blocs: [
          { p: 'MirumGames.com collecte les données personnelles nécessaires pour :' },
          {
            liste: [
              'Traiter votre commande (nom, adresse, email, téléphone)',
              'Vous envoyer les confirmations de commande et avis de livraison',
              'Gérer votre compte client',
              'Vous adresser nos newsletters (avec votre consentement)',
              'Améliorer nos services',
            ],
          },
        ],
      },
      {
        titre: '2. Utilisation des Données',
        blocs: [
          { p: 'Vos données ne sont utilisées que pour les fins énumérées ci-dessus. MirumGames.com ne communique jamais vos données à des tiers sans votre consentement explicite.' },
          { p: 'Les seules exceptions sont :' },
          {
            liste: [
              'Les prestataires logistiques pour la livraison',
              'STRIPE pour le traitement des paiements',
              "Les autorités publiques si la loi l'exige",
            ],
          },
        ],
      },
      {
        titre: '3. Cookies',
        blocs: [
          { p: 'MirumGames.com utilise des cookies pour améliorer votre expérience utilisateur, notamment pour :' },
          {
            liste: [
              'Mémoriser vos préférences de navigation',
              "Gérer votre panier d'achat",
              'Personnaliser votre expérience',
            ],
          },
          { p: 'Vous pouvez à tout moment désactiver les cookies via les paramètres de votre navigateur. Cependant, cela peut affecter le fonctionnement du site.' },
          { p: "<strong>Mesure d'audience :</strong> nous utilisons une mesure de fréquentation interne, sans cookie et sans donnée personnelle. Ni votre adresse IP ni votre historique de navigation ne sont conservés : seules des statistiques agrégées et anonymes (pages vues, nombre de visiteurs par jour) sont produites. Ce dispositif ne permet pas de vous suivre d'un jour à l'autre ni d'un site à l'autre, et vous pouvez le refuser à tout moment via le lien « Gérer mes cookies » en bas de page." },
        ],
      },
      {
        titre: '4. Droits des Utilisateurs (RGPD)',
        blocs: [
          { p: 'En tant que résident en Europe, vous avez les droits suivants :' },
          {
            liste: [
              "<strong>Droit d'accès :</strong> Vous pouvez demander l'accès à vos données personnelles",
              '<strong>Droit de rectification :</strong> Vous pouvez corriger vos données inexactes',
              "<strong>Droit à l'oubli :</strong> Vous pouvez demander la suppression de vos données",
              '<strong>Droit à la limitation :</strong> Vous pouvez limiter le traitement de vos données',
              '<strong>Droit à la portabilité :</strong> Vous pouvez recevoir vos données dans un format structuré',
              "<strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données",
            ],
          },
          { p: `Pour exercer ces droits, contactez ${COURRIEL}.` },
        ],
      },
      {
        titre: '5. Sécurité des Données',
        blocs: [
          { p: 'MirumGames.com met en place des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données :' },
          {
            liste: [
              'Chiffrement SSL/TLS de toutes les connexions',
              'Accès restreint aux données personnelles',
              'Sauvegarde régulière des données',
              'Conformité avec le RGPD',
            ],
          },
        ],
      },
      {
        titre: '6. Durée de Conservation',
        blocs: [
          { p: 'Vos données personnelles sont conservées aussi longtemps que nécessaire pour :' },
          {
            liste: [
              "L'exécution de votre commande et des garanties",
              'Le respect des obligations légales (notamment fiscales)',
              'La gestion de votre compte client',
            ],
          },
          { p: 'Après cette période, vos données sont supprimées ou anonymisées.' },
        ],
      },
      {
        titre: '7. Tiers',
        blocs: [
          { p: 'MirumGames.com peut partager vos données avec les prestataires suivants :' },
          {
            liste: [
              '<strong>STRIPE</strong> : pour le traitement des paiements',
              '<strong>Sendcloud</strong> : pour la gestion des expéditions et livraisons',
              "<strong>Sentry</strong> : pour la remontée des erreurs techniques du site. Seules les informations nécessaires au diagnostic d'une panne sont transmises ; aucun enregistrement de votre navigation n'est réalisé.",
              '<strong>Hébergement</strong> : pour stocker le site et les données',
            ],
          },
          { p: 'Tous ces prestataires sont tenus de respecter la confidentialité de vos données.' },
        ],
      },
      {
        titre: '8. Contact',
        blocs: [
          { p: 'Pour toute question concernant votre confidentialité, contactez :' },
          { p: `<strong>Responsable du traitement :</strong> Sébastien Schoonjans (MirumGames.com)<br /><strong>Email :</strong> ${COURRIEL}<br /><strong>Adresse :</strong> ${ADRESSE}` },
          { p: "Les données des comptes clients existants ont été reprises par Sébastien Schoonjans avec l'activité du site, le 23/09/2026." },
        ],
      },
    ],
  },

  mentions: {
    seoTitre: 'Mentions Légales',
    seoDescription:
      "Mentions légales de MirumGames : informations sur l'entreprise, propriétaire du site, numéro de TVA et coordonnées.",
    titre: 'Mentions Légales',
    maj: 'Dernière mise à jour : 23/09/2026',
    sections: [
      {
        titre: "Informations sur l'Entreprise",
        blocs: [
          {
            encadre: encadreIdentite({
              nom: "Nom de l'entreprise",
              statut: 'Statut',
              statutValeur: 'entrepreneur indépendant (personne physique)',
              adresse: 'Adresse',
              pays: 'Belgique',
              bce: "Numéro d'entreprise (BCE)",
              tva: 'Numéro de TVA',
              email: 'Email',
              telephone: 'Téléphone',
              sep: ' :',
            }),
          },
        ],
      },
      {
        titre: 'Directeur de la Publication',
        blocs: [
          { p: '<strong>Sébastien Schoonjans</strong><br />Responsable de la publication du site MirumGames.com' },
        ],
      },
      {
        titre: 'Hébergement du Site',
        blocs: [
          // Le texte d'origine annonçait un « K3s Cluster », qui n'est plus la
          // façon dont l'application est déployée. On ne remplace pas une
          // information périmée par une supposition : le nom et l'adresse de
          // l'hébergeur restent à compléter par l'exploitante.
          { p: 'Le site MirumGames.com est hébergé par :<br /><strong>Cloudflare Pages</strong> (interface publique)<br /><strong>Serveur dédié</strong> (application et base de données)<br /><br />Les données sont hébergées dans l\'Union européenne et traitées conformément au RGPD.' },
        ],
      },
      {
        titre: 'Propriété Intellectuelle',
        blocs: [
          { p: "L'ensemble du contenu du site MirumGames.com (textes, images, illustrations, logos, vidéos, etc.) est protégé par les lois sur la propriété intellectuelle." },
          { p: "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de l'éditeur du site, Sébastien Schoonjans." },
        ],
      },
      {
        titre: 'Taxes et Redevances',
        blocs: [
          { p: 'Nous attirons votre attention sur le fait que nos prix comprennent les taxes et redevances en vigueur en Belgique. Les législations diffèrent selon les pays.' },
          { p: "L'acheteur vérifiera si d'autres taxes ou redevances sont dues dans son pays de résidence et devra s'acquitter, le cas échéant, des redevances, taxes et charges de toutes natures concernant les produits qu'il aura importés dans son pays." },
        ],
      },
      {
        titre: 'Limitation de Responsabilité',
        blocs: [
          { p: "L'éditeur du site s'efforce d'assurer l'exactitude et la mise à jour des informations qui y sont diffusées, et se réserve le droit d'en corriger le contenu à tout moment et sans préavis." },
          { p: "Toutefois, l'éditeur du site ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site." },
        ],
      },
      {
        titre: 'Cookies et Données Personnelles',
        blocs: [
          { p: 'Pour toute information concernant l\'utilisation de cookies et la protection de vos données personnelles, consultez notre <a href="/privacy" class="text-blue-600 hover:text-blue-800 underline">Politique de Confidentialité</a>.' },
        ],
      },
      {
        titre: 'Droit Applicable',
        blocs: [
          { p: "Les présentes mentions légales sont régies par le droit belge. En cas de litige, le consommateur s'adressera en priorité à MirumGames.com pour obtenir une solution amiable." },
          { p: 'À défaut, ledit litige sera soumis à la compétence exclusive des juridictions belges compétentes.' },
        ],
      },
      {
        titre: 'Contact',
        blocs: [
          { p: `Pour toute question concernant les mentions légales, vous pouvez nous contacter à :<br /><strong>Email :</strong> ${COURRIEL}<br /><strong>Adresse :</strong> ${ADRESSE}<br /><strong>Téléphone :</strong> ${TELEPHONE}` },
        ],
      },
    ],
  },

  paiement: {
    seoTitre: 'Sécurité des Paiements',
    seoDescription:
      'Sécurité des paiements sur MirumGames : transactions confiées à Stripe, chiffrement SSL/TLS, certifications PCI-DSS et conseils pratiques.',
    titre: 'Sécurité des Paiements',
    maj: 'Dernière mise à jour : 18/02/2024',
    sections: [
      {
        titre: 'Paiement via STRIPE',
        blocs: [
          { p: "La sécurisation des transactions bancaires est d'une importance primordiale. MirumGames.com a choisi de s'appuyer sur l'expertise du prestataire STRIPE pour garantir la sécurité maximale de vos paiements." },
        ],
      },
      {
        titre: 'Est-il sûr de payer avec MirumGames ?',
        blocs: [
          { p: "Oui ! Pendant la phase de paiement, l'intégralité de la transaction s'effectue via le prestataire STRIPE en mode chiffré. Vous quittez temporairement le site MirumGames.com en toute transparence pour communiquer vos coordonnées bancaires." },
          { p: 'Cela garantit que :' },
          {
            liste: [
              "MirumGames.com ne connaîtra jamais votre numéro de carte ni n'aura accès à vos données bancaires",
              'MirumGames.com ne connaîtra pas les détails de vos transactions — seuls le montant total et le numéro de commande nous sont transmis',
              'Vos données bancaires sont traitées exclusivement par STRIPE, un prestataire certifié et de confiance',
            ],
          },
        ],
      },
      {
        titre: 'Quelles sont les mesures de sécurité de STRIPE ?',
        blocs: [
          { p: 'STRIPE utilise le système de chiffrement standardisé connu sous le nom de « Protocole SSL » (Secure Sockets Layer).' },
          { p: 'Lorsque vous êtes sur la page de paiement, vérifiez ces indicateurs de sécurité :' },
          {
            liste: [
              '<strong>Pictogramme de sécurité :</strong> un cadenas fermé doit apparaître dans le coin de votre navigateur',
              '<strong>Barre d\'adresse :</strong> l\'URL doit commencer par « https:// » (et non « http:// »)',
              'Le « s » de https indique une connexion sécurisée et chiffrée',
            ],
          },
          { p: "Si vous voyez un message d'avertissement, c'est que vous passez d'un mode chiffré à un mode non chiffré (ou vice versa). Dans ce cas, vérifiez avant d'entrer vos données confidentielles." },
        ],
      },
      {
        titre: 'Certifications STRIPE',
        blocs: [
          { p: 'STRIPE respecte les normes les plus strictes :' },
          {
            liste: [
              '<strong>PCI-DSS</strong> (Payment Card Industry Data Security Standard) : certification de sécurité maximale pour les paiements par carte',
              '<strong>RGPD</strong> : conformité totale avec la réglementation européenne',
              "<strong>ISO 27001</strong> : certification de gestion de la sécurité de l'information",
              '<strong>SOC 2 Type II</strong> : audit de sécurité et de conformité indépendant',
            ],
          },
        ],
      },
      {
        titre: 'Recommandations de Sécurité',
        blocs: [
          { p: 'Pour garantir votre sécurité lors du paiement :' },
          {
            liste: [
              '✓ Utilisez toujours la dernière version de votre navigateur',
              '✓ N\'effectuez les paiements que sur des connexions sécurisées (pas sur un WiFi public non sécurisé)',
              '✓ Vérifiez toujours que le cadenas est fermé et que l\'URL commence par « https:// »',
              '✓ Ne partagez jamais vos données de paiement par email ou téléphone',
              '✓ Vérifiez régulièrement votre relevé bancaire pour détecter toute activité suspecte',
            ],
          },
        ],
      },
      {
        titre: 'Que se passe-t-il après le paiement ?',
        blocs: [
          { p: 'Une fois le paiement validé :' },
          {
            liste: [
              'Vous recevez une confirmation de commande par email',
              'MirumGames.com reçoit uniquement le montant total et votre numéro de commande',
              'STRIPE stocke vos données de paiement de manière sécurisée',
              'Votre commande est préparée et expédiée',
            ],
          },
        ],
      },
      {
        titre: 'En cas de Problème',
        blocs: [
          { p: 'Si vous constatez une activité suspecte sur votre compte :' },
          {
            liste: [
              'Contactez immédiatement votre banque',
              `Envoyez un email à ${COURRIEL} avec les détails du problème`,
              'Signalez le problème à STRIPE directement',
            ],
          },
        ],
      },
      {
        titre: 'Questions Fréquentes',
        blocs: [
          { p: '<strong>Q : MirumGames.com garde-t-il mes données de carte ?</strong><br />R : Non, absolument pas. STRIPE seul gère vos données bancaires.' },
          { p: `<strong>Q : Comment puis-je supprimer mes données de paiement ?</strong><br />R : Contactez ${COURRIEL} pour demander la suppression de vos données.` },
          { p: "<strong>Q : Puis-je utiliser plusieurs méthodes de paiement ?</strong><br />R : Oui, STRIPE accepte les cartes de crédit, les cartes de débit et d'autres méthodes selon votre localisation." },
        ],
      },
      {
        titre: "Pour Plus d'Informations",
        blocs: [
          { p: 'Pour plus de détails sur la sécurité STRIPE, visitez : <a href="https://stripe.com/security" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">stripe.com/security</a>' },
        ],
      },
    ],
  },
};
